module.exports = __webpack_public_path__ + "img/image20.e755c0bd.png";